import { render, staticRenderFns } from "./broadcast-points.vue?vue&type=template&id=73ea429a&scoped=true"
import script from "./broadcast-points.vue?vue&type=script&lang=js"
export * from "./broadcast-points.vue?vue&type=script&lang=js"
import style0 from "./broadcast-points.vue?vue&type=style&index=0&id=73ea429a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ea429a",
  null
  
)

export default component.exports